import Axios from "axios";
import { toArray } from "@thinkvn/utils";
export const createAxiosExtra = (axios) => {
  for (const method of ["request", "delete", "get", "head", "options", "post", "put", "patch"]) {
    axios["$" + method] = function() {
      return this[method].apply(this, arguments).then((res) => res && res.data);
    };
  }
  axios.setBaseURL = (baseURL) => {
    axios.defaults.baseURL = baseURL;
  };
  axios.setHeader = (name, value, scopes = "common") => {
    for (const scope of toArray(scopes)) {
      if (!value) {
        delete axios.defaults.headers[scope][name];
        continue;
      }
      axios.defaults.headers[scope][name] = value;
    }
  };
  axios.setToken = (token, type, scopes = "common") => {
    const value = token ? (type ? `${type} ` : "") + token : "";
    axios.setHeader("Authorization", value, scopes);
  };
  axios.onRequest = (callback) => {
    axios.interceptors.request.use((config) => callback(config) || config);
  };
  axios.onResponse = (callback) => {
    axios.interceptors.response.use((response) => callback(response) || response);
  };
  axios.onRequestError = (callback) => {
    axios.interceptors.request.use(void 0, (error) => callback(error) || Promise.reject(error));
  };
  axios.onResponseError = (callback) => {
    axios.interceptors.response.use(void 0, (error) => callback(error) || Promise.reject(error));
  };
  axios.onError = (callback) => {
    axios.onRequestError(callback);
    axios.onResponseError(callback);
  };
  axios.isCancel = Axios.isCancel;
};
